<template>
    <div class="product-combo d-flex">
        <ProductPriceFrame label="Preço normal" :price="regularPrice" />

        <div class="product-combo-divider text-secondary text-uppercase text-bold">
            {{ $t('or') }}
        </div>

        <ProductPriceFrame
            primary
            label="Preço no combo"
            :price="product.promo_combo_unit_price"
            :description="product.promo_instruction"
        />
    </div>
</template>

<script>
    import { productStore } from '../../common/store/product-store';
    import ProductPriceFrame from './ProductPriceFrame';

    export default {
        name: 'ProductPageComboPrice',

        components: { ProductPriceFrame },

        data() {
            return {
                productStoreState: productStore.state,
            };
        },

        computed: {
            product() {
                return this.productStoreState.product;
            },

            regularPrice() {
                return this.product.price_min > 0 ? this.product.price_min : this.product.price;
            },
        },
    };
</script>
